import { render, staticRenderFns } from "./RegistroCaja.vue?vue&type=template&id=5a1d2cb1"
import script from "./RegistroCaja.vue?vue&type=script&lang=js"
export * from "./RegistroCaja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports